"use client";

import { useId } from "react";
import { Input } from "@/components/ui/input";
import { useFilterSheetContext } from "@/components/sheets/FilterSheet/context";
import {
	filterSheetGlassInputClassName,
	filterSheetHeadingClassName,
} from "@/components/sheets/FilterSheet/filter-sheet-glass";

export default function FilterBudgetSection() {
	const { mutSearchParams } = useFilterSheetContext();
	const minPriceId = useId();
	const maxPriceId = useId();

	const defaultMin = mutSearchParams.has("minPrice")
		? Number.parseFloat(mutSearchParams.get("minPrice")!)
		: undefined;

	const defaultMax = mutSearchParams.has("maxPrice")
		? Number.parseFloat(mutSearchParams.get("maxPrice")!)
		: undefined;

	return (
		<div className="flex flex-col gap-2">
			<h3 className={filterSheetHeadingClassName}>Budget</h3>

			<div className="grid grid-cols-[1fr_1rem_1fr] items-center gap-2">
				<label htmlFor={minPriceId} className="sr-only">
					Minimum price
				</label>
				<Input
					id={minPriceId}
					type="number"
					name="minPrice"
					placeholder="Minimum"
					defaultValue={defaultMin}
					autoComplete="off"
					className={filterSheetGlassInputClassName}
				/>
				<span className="text-white/70" aria-hidden>
					-
				</span>
				<label htmlFor={maxPriceId} className="sr-only">
					Maximum price
				</label>
				<Input
					id={maxPriceId}
					type="number"
					name="maxPrice"
					placeholder="Maximum"
					defaultValue={defaultMax}
					autoComplete="off"
					className={filterSheetGlassInputClassName}
				/>
			</div>
		</div>
	);
}
